import fb from '../../../firebaseConfig';
import Vue from 'vue';

const userWorkspaceLiteModule = {
  //  Easy VUEX firestore configuration
  firestorePath: 'userWorkspaceLite',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'userWorkspaceLite',
  statePropName: 'userWorkspaceLiteData',
  namespaced: true,
  serverChange: {
    addedHook: function(updateStore, doc, id, store) {
      const userWorkspaceLiteData = store.state.userWorkspaceLite.userWorkspaceLiteData;
      Vue.set(userWorkspaceLiteData, id, doc);
      Object.values(doc.documentData).forEach(d => {
        // console.log(store);
        const docs = store.state.userWorkspaceLite.allUserDocuments;
        Vue.set(docs, d.id, { ...d, fbDocId: id, workspace: doc.workspaceId });
        // if (docs[doc.workspaceId]) {

        // } else {
        //   const update = {};
        //   update[d.id] = { ...d, fbDocId: d.id };
        //   Vue.set(docs, [doc.workspaceId], update);
        // }
      });
      // updateStore(doc);
    },
    modifiedHook: function(updateStore, doc, id, store) {
      const userWorkspaceLiteData = store.state.userWorkspaceLite.userWorkspaceLiteData;
      Vue.set(userWorkspaceLiteData, id, doc);
      console.log('server change context', doc);
      console.log(doc);
      Object.values(doc.documentData).forEach(d => {
        // console.log(store);
        if (d.toDelete) return;
        const docs = store.state.userWorkspaceLite.allUserDocuments;
        Vue.set(docs, d.id, { ...d, fbDocId: id, workspace: doc.workspaceId });
        // if (docs[doc.workspaceId]) {

        // } else {
        //   const update = {};
        //   update[d.id] = { ...d, fbDocId: d.id };
        //   Vue.set(docs, [doc.workspaceId], update);
        // }
      });
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'serverChange',
      //   collection: 'contexts',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      // updateStore(doc);
    }
  },
  state: {
    allUserDocuments: {}
  },
  getters: {
    // allUserDocuments: (state, getters) => {
    //   const currentUserWorkspaceLite = getters.currentUserWorkspaceLite;
    //   return currentUserWorkspaceLite ? currentUserWorkspaceLite.documentData : {};
    //   console.log('calc allUserDocuments');
    //   // TODO: incorporate other documents in case size limit is hit
    //   const workspaces = Object.values(state.userWorkspaceLiteData);
    //   console.log('allUserDocuments updated');
    //   let result = {};
    //   if (workspaces) {
    //     workspaces.forEach(w => {
    //       result = w.documentData;
    //       // const { documentData } = w;
    //       // result = { ...result, ...documentData };
    //       // const dData = { ...documentData }; // clone documentData
    //       // Object.keys(documentData).forEach(id => {
    //       //   dData[id] = { ...dData[id], fbDocId: w.id };
    //       // });
    //       // result = Object.assign(result, dData);
    //     });
    //   }
    //   return result;
    // },
    workspaceResources: (state, getters, rootState) => {
      const { currentWorkspaceId } = rootState.workspaces;
      console.log('calc workspaceResources');
      //  Get all contexts from userWorkspaceLite based on currentWorkspaceId
      // const currentUserWorkspaceLite = getters.currentUserWorkspaceLite;
      try {
        return Object.values(state.allUserDocuments).filter(
          d => d.workspace == currentWorkspaceId && d.type == 'resource'
        );
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    currentUserWorkspaceLite: (state, getters, rootState) => {
      console.log('calc currentUserWOrkspaceLite');
      const { currentWorkspaceId } = rootState.workspaces;
      const uwld = state.userWorkspaceLiteData;
      // TODO: incorporate other documents in case size limit is hit
      console.log('update current user workspace lite');
      return Object.values(uwld).find(w => w.workspaceId == currentWorkspaceId);
    }
  },
  mutations: {
    addNewContextToLite(state, { currentWorkspaceId, doc }) {
      try {
        Vue.set(state.allUserDocuments, doc.id, { ...doc, workspace: currentWorkspaceId });
        Vue.set(
          state.userWorkspaceLiteData[state.currentUserWorkspaceLite.id].documentData,
          doc.id,
          doc
        );
      } catch (e) {
        console.log('could not update vuex');
      }
    },
    removeDocFromLite(state, { docId }) {
      Vue.set(state.allUserDocuments, docId, { toDelete: true });
      Vue.delete(
        state.userWorkspaceLiteData[state.currentUserWorkspaceLite.id].documentData,
        docId
      );
    }
  },
  actions: {
    subscribeToUserWorkspaceLite({ dispatch, rootGetters }) {
      return new Promise((resolve, reject) => {
        //get userId and throw an error if there are any problems getting the user ID
        if (!rootGetters['auth/isUser']) {
          reject('auth/isUser is set to false');
        }
        const userId = rootGetters['auth/userId'];

        dispatch('openDBChannel', {
          where: [['userId', '==', userId]]
        })
          .then(() => {
            console.log('subscribe to user workspace lite');
            resolve('subscribed to userWorkspaceLite');
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    unsubscribeToUserWorkspaceLite({ dispatch }) {
      console.log('unsubscribe for userWorkspaceLite');
      dispatch('closeDBChannel', { clearModule: true });
    },
    createUserWorkspaceLite({ dispatch }, { userId, workspaceId }) {
      const doc = {
        userId,
        workspaceId,
        documentData: {}
      };
      dispatch('insert', doc);
    },
    updateContextUserStatus({ dispatch }, { status, userWorkspaceLiteId, contextId }) {
      //create an update object with the users data
      const documentData = {};
      documentData[contextId] = { userStatus: status };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: userWorkspaceLiteId, documentData });
    },
    updateContextLastOpened({ dispatch, state, getters }, { contextId }) {
      //create an update object with the users data
      const documentData = {};
      documentData[contextId] = { lastOpenedByUser: fb.util.FieldValue.serverTimestamp() };

      //find which document to update
      const { allUserDocuments } = state;
      console.log('alluserdocs', allUserDocuments);
      const UWLdataForContext = allUserDocuments[contextId];
      //update vuex and database with vuex-easy-firestore
      console.log('UWLdataForContext', UWLdataForContext);
      if (UWLdataForContext) {
        dispatch('patch', { id: UWLdataForContext.fbDocId, documentData });
      }
    },
    addNewContextToLiteVuexOnly({ commit, rootState }, { doc }) {
      // const { currentUserWorkspaceLite } = getters;
      const { currentWorkspaceId } = rootState.workspaces;
      if (currentWorkspaceId !== null) {
        commit('addNewContextToLite', { doc, currentWorkspaceId });
      }
    },
    removeDocWorkspaceLiteVuexOnly({ commit, rootState }, { docId }) {
      // const { currentUserWorkspaceLite } = getters;
      const { currentWorkspaceId } = rootState.workspaces;
      if (currentWorkspaceId !== null) {
        commit('removeDocFromLite', { docId, currentWorkspaceId });
      }
    }
  }
};

export default userWorkspaceLiteModule;
